<template>
  <wizard-form v-on="$listeners" v-bind="$attrs">
    <template #content>
      <SecurityTransferForm :security-transfer="securityTransfer" />
    </template>
  </wizard-form>
</template>
<script>
import WizardForm from '@/components/commons/WizardForm'
import { mapState } from 'vuex'
import SecurityTransferForm from './forms/SecurityTransferForm'
export default {
  components: {
    WizardForm,
    SecurityTransferForm
  },
  props: {
    securityTransfer: {
      type: Object,
      required: true
    }
  },
  data() {
    return {}
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('account', ['account', 'accountData']),
    isExecutive() {
      return (
        this.user?.authorityLevelsCode === 1 ||
        this.user?.authorityLevelsCode === 2 ||
        this.user?.authorityLevelsCode === 4
      )
    },
    isAccountCode() {
      return (
        this.user?.avobjects?.findIndex(
          item =>
            item.code === this.account.code && item.typeCode === 'accountCode'
        ) > -1
      )
    }
  },
  methods: {}
}
</script>
<style scoped>
.main-container {
  line-height: normal;
}

hr {
  margin: 0;
  padding: 0;
}

hr.rounded {
  border-top: 2px solid;
  width: 400px;
}
</style>
